import {
  CreateQuestionRequest,
  GetQuestionListForMyQuestionResponse,
} from './Question.api.type';
import { QuestionReaction } from './Question.type';

/**
 * 설문 관련 타입 초기화 모음
 */
export const questionInitializer = {
  /**
   * 설문 등록 요청 파라미터 초기화
   */
  INITIAL_CREATE_QUESTION_PARAM: {
    title: '',
    description: '',
    options: ['', ''],
    categoryId: '',
    isAnonymous: false,
    expiresAt: undefined,
    presetDuration: 24,
    memberOnly: false,
  } as CreateQuestionRequest,

  /**
   * 설문상세 조회 초기화
   */
  INITIAL_QUESTION_DETAIL: {
    questionId: '',
    regDateTime: '',
    endDate: '',
    isExpired: false,
    profileImageUrl: '',
    username: '',
    questionTitle: '',
    questionContent: '',
    questionOptions: [],
    hasVoted: false,
    userVotedOrder: -1,
    categoryEmoji: '',
    categoryNameKr: '',
    categoryId: '',
    userId: 0,
    memberOnly: false,
    questionReaction: {} as QuestionReaction,
    reactions: [],
    comments: [],
    isFavorited: false,
    totalVoteCount: 0,
    canEdit: false,
    canDelete: false,
  },

  INITIAL_GET_QUESTION_LIST_FOR_MY_QUESTION: {
    questions: [],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  } as GetQuestionListForMyQuestionResponse,
};
